import React, { Component } from 'react';
import { Translate } from 'react-redux-i18n';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import { fetchGroups, fetchGroupCategories } from '../../actions/products_actions';

class GroupsModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      groups: [],
    };
  }

  componentDidMount() {
    this.props.fetchGroups();
  }

  handleDealGroups = (groups) => {
    let data = [];
    let cpGroups = groups.map(group => {
      let groupIndex = this.props.data.findIndex(dtGroup => dtGroup.ProductGroup_id == group.ProductGroup_id);
      let Categories = group.Categories.map(category => {
        if (groupIndex != -1 && this.props.data[groupIndex].Categories.findIndex(dtCategory => dtCategory.ProductCategory_id == category.ProductCategory_id) != -1) {
          data.push({
            groupId: group.ProductGroup_id,
            categoryId: category.ProductCategory_id,
            name: `${group.Name || group.GroupName} - ${category.Name}`,
            checked: true,
          });
          return { ...category, checked: true }
        } else {
          data.push({
            groupId: group.ProductGroup_id,
            categoryId: category.ProductCategory_id,
            name: `${group.Name || group.GroupName} - ${category.Name}`,
            checked: false,
          });
          return { ...category, checked: false }
        }
      });
      return { ...group, Categories };
    });

    this.setState({ data, groups: cpGroups });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.groups != this.props.groups) {
      this.handleDealGroups(nextProps.groups || []);
    }
  }

  handleCheckCategory = (groupId, categoryId, checked) => {
    let data = this.state.data.map((group) => {
      if (group.groupId == groupId && group.categoryId == categoryId) {
        return { ...group, checked }
      }
      return { ...group };
    });
    let groups = this.state.groups.map(group => {
      if (group.ProductGroup_id == groupId) {
        let Categories = group.Categories.map(category => {
          if (category.ProductCategory_id == categoryId) {
            return { ...category, checked };
          }
          return { ...category };
        })
        return { ...group, Categories };
      }
      return { ...group };
    })
    this.setState({
      data,
      groups,
    });
  }

  handleConfirm = () => {
    let groups = [];
    this.state.groups.map(group => {
      let categories = [];
      group.Categories.map(category => {
        if (category.checked) {
          categories.push({
            ProductCategory_id: category.ProductCategory_id,
            Name: category.Name,
            Description: category.Description,
          })
        }
      });
      if (categories.length) {
        groups.push({
          ProductGroup_id: group.ProductGroup_id,
          GroupNum: group.GroupNum,
          Name: group.Name,
          Description: group.Description,
          Categories: categories,
        })
      }
    })
    this.props.confirm(groups);
  }

  render() {
    return (
      <div style={styles.container}>
        {/* group and category */}
        <div style={styles.list_group}>
          {this.state.data.map((group, index) => {
            return <div
              key={index}
              style={styles.list_item}
              onClick={() => { this.handleCheckCategory(group.groupId, group.categoryId, !group.checked) }}
            >
              <input type="checkbox" checked={group.checked}
                onChange={(event) => {
                  this.handleCheckCategory(group.groupId, group.categoryId, event.target.checked)
                }} />
              <div>
                {group.name}
              </div>
            </div>
          })}
        </div>
        {/* button */}
        <div style={styles.bottom}>
          <div style={styles.btn_v}>
            <Button
              bsStyle='danger'
              onClick={() => {
                this.props.close();
              }}
            >
              <Translate value='cancel' />
            </Button>
            <Button
              bsStyle='primary'
              onClick={this.handleConfirm}>
              <Translate value='confirm' />
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '500px',
    backgroundColor: 'aliceblue'
  },
  list_group: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'scroll',
    height: '450px',
    width: '100%'
  },
  list_item: {
    width: '100%',
    minHeight: '26px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingLeft: '10px',
  },
  bottom: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '10px',
  },
  btn_v: {
    display: 'flex',
    flexDirection: 'row',
    width: '60%',
    height: '26px',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
}

function mapStateToProps(state) {
  return {
    groups: state.products.groups,
    groupIsLoading: state.products.groupIsLoading,
    groupError: state.products.groupError,
    currentGroup: state.products.currentGroup,
    selectedWarehouse: state.header.selectedWarehouse,
    selectedCompany: state.header.selectedCompany,
  };
}

export default connect(mapStateToProps, {
  fetchGroups,
  fetchGroupCategories,
})(GroupsModal);



// WEBPACK FOOTER //
// ./master/jsx/components/Vendors/GroupsModal.jsx